interface Pole {
  index: string;
  name: string;
  schools: string[];
}

const POLES: Pole[] = [
  { index: 'I', name: 'Médecine & Pharmacie', schools: ['FMP', 'FMD'] },
  { index: 'II', name: 'Commerce & Gestion', schools: ['ENCG', 'ISCAE'] },
  { index: 'III', name: 'Ingénierie', schools: ['ENSAM', 'ENSA', 'ENAM', 'IAV–ENCK'] },
  { index: 'IV', name: 'Pack Général + ENA', schools: ['Préparation complète', 'Tous concours'] },
];

const Poles = () => (
  <section className="ppb-poles" id="poles">
    <div className="container">
      <div className="ppb-poles-head">
        <p className="ppb-eyebrow">Nos pôles</p>
        <h2 className="ppb-section-title">
          Quatre pôles, <span className="emph">une même ambition</span>.
        </h2>
        <p className="ppb-section-lede">
          Chaque pôle prépare aux concours de ses écoles et facultés cibles,
          avec un programme pensé pour les exigences de l'examen.
        </p>
      </div>

      <div className="ppb-poles-grid">
        {POLES.map((pole) => (
          <article key={pole.name} className="ppb-pole-card">
            <p className="ppb-pole-index">{pole.index}</p>
            <h3 className="ppb-pole-name">{pole.name}</h3>
            <p className="ppb-pole-schools-label">Écoles &amp; facultés cibles</p>
            <div className="ppb-pole-schools">
              {pole.schools.map((school) => (
                <span key={school} className="ppb-pole-chip">{school}</span>
              ))}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Poles;
